import MoocsScreen from './containers/moocsScreen'

export {default as MoocsScreenLayout} from './components/moocsScreenLayout'

export default MoocsScreen
